var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-form",
        {
          ref: "detailForm",
          attrs: {
            model: _vm.detail,
            rules: _vm.rules,
            "label-width": "120px",
            "label-position": _vm.device === "mobile" ? "top" : "right",
          },
        },
        [
          _c(
            "el-collapse",
            {
              staticClass: "el-card-collapse",
              model: {
                value: _vm.activeCollapses,
                callback: function ($$v) {
                  _vm.activeCollapses = $$v
                },
                expression: "activeCollapses",
              },
            },
            [
              _c(
                "el-collapse-item",
                { attrs: { title: "基本信息", name: "Basic" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 16 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品名称", prop: "goodsName" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入商品名称" },
                                model: {
                                  value: _vm.detail.goodsName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detail,
                                      "goodsName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "detail.goodsName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "商品单位" },
                            },
                            [
                              _c("el-input", {
                                staticClass: "max-width",
                                attrs: { placeholder: "件/箱/个/盒 等" },
                                model: {
                                  value: _vm.detail.goodsUnit,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detail,
                                      "goodsUnit",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "detail.goodsUnit",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "所属品牌" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择所属品牌" },
                                  model: {
                                    value: _vm.detail.brandId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "brandId", $$v)
                                    },
                                    expression: "detail.brandId",
                                  },
                                },
                                _vm._l(_vm.brands, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.brandName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "所属分类" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择所属分类" },
                                  model: {
                                    value: _vm.detail.categoryId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "categoryId", $$v)
                                    },
                                    expression: "detail.categoryId",
                                  },
                                },
                                _vm._l(_vm.categories, function (group) {
                                  return _c(
                                    "el-option-group",
                                    {
                                      key: group.name,
                                      attrs: { label: group.name },
                                    },
                                    _vm._l(group.children, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "显示排序" },
                            },
                            [
                              _c("el-input", {
                                staticClass: "max-width",
                                attrs: { placeholder: "商品在前端的排序" },
                                model: {
                                  value: _vm.detail.sortBy,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "sortBy", $$v)
                                  },
                                  expression: "detail.sortBy",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 16 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "供应商" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择供应商",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detail.supplierId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "supplierId", $$v)
                                    },
                                    expression: "detail.supplierId",
                                  },
                                },
                                _vm._l(_vm.suppliers, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.supplierName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品图片", prop: "cover" } },
                            [
                              _c(
                                "div",
                                { staticClass: "image-uploader" },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "avatar-uploader",
                                      attrs: {
                                        action: "#",
                                        accept: "image/*",
                                        "show-file-list": false,
                                        "on-change": _vm.imageChange.bind(
                                          null,
                                          { key: "cover" }
                                        ),
                                        "http-request": _vm.imageUpload.bind(
                                          null,
                                          { key: "cover" }
                                        ),
                                      },
                                    },
                                    [
                                      _vm.coverImage.url
                                        ? [
                                            _c("img", {
                                              staticClass: "avatar",
                                              attrs: {
                                                src: _vm.coverImage.url,
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "el-upload-img-actions",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-img-preview",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.imagePreview(
                                                          { key: "cover" }
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-zoom-in",
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-img-delete",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.imageBeforeRemove(
                                                          { key: "cover" }
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-delete",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _c("i", {
                                            staticClass:
                                              "el-icon-camera avatar-uploader-icon",
                                          }),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 16 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "商品轮播图", prop: "galleries" },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    action: "#",
                                    limit: 9,
                                    multiple: "",
                                    accept: "image/*",
                                    "list-type": "picture-card",
                                    "file-list": _vm.galleries,
                                    "on-change": _vm.imageChange.bind(null, {
                                      key: "galleries",
                                    }),
                                    "on-remove": _vm.imageRemove.bind(null, {
                                      key: "galleries",
                                    }),
                                    "on-preview": _vm.imagePreview.bind(null, {
                                      key: "galleries",
                                    }),
                                    "http-request": _vm.imageUpload.bind(null, {
                                      key: "galleries",
                                    }),
                                    "before-remove": _vm.imageBeforeRemove.bind(
                                      null,
                                      { key: "galleries" }
                                    ),
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-camera" })]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 8, sm: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "新品" },
                            },
                            [
                              _c("el-switch", {
                                staticClass: "rectangle",
                                attrs: {
                                  width: 60,
                                  "active-color": "#13ce66",
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.detail.isNew,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "isNew", $$v)
                                  },
                                  expression: "detail.isNew",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 8, sm: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "推荐" },
                            },
                            [
                              _c("el-switch", {
                                staticClass: "rectangle",
                                attrs: {
                                  width: 60,
                                  "active-color": "#13ce66",
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.detail.isHot,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "isHot", $$v)
                                  },
                                  expression: "detail.isHot",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 8, sm: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "上架" },
                            },
                            [
                              _c("el-switch", {
                                staticClass: "rectangle",
                                attrs: {
                                  width: 60,
                                  "active-color": "#13ce66",
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.detail.isOnsale,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "isOnsale", $$v)
                                  },
                                  expression: "detail.isOnsale",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "商品价格", name: "Prices" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "供货价", prop: "stockPrice" },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "max-width",
                                  attrs: {
                                    type: "number",
                                    placeholder: "请输入供货价",
                                  },
                                  model: {
                                    value: _vm.detail.stockPrice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "stockPrice", $$v)
                                    },
                                    expression: "detail.stockPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "成本价", prop: "costPrice" },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "max-width",
                                  attrs: {
                                    type: "number",
                                    placeholder: "请输入成本价",
                                  },
                                  model: {
                                    value: _vm.detail.costPrice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "costPrice", $$v)
                                    },
                                    expression: "detail.costPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "零售价", prop: "retailPrice" },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "max-width",
                                  attrs: {
                                    type: "number",
                                    placeholder: "请输入零售价",
                                  },
                                  model: {
                                    value: _vm.detail.retailPrice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "retailPrice", $$v)
                                    },
                                    expression: "detail.retailPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "积分售价", prop: "pointPrice" },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "max-width",
                                  attrs: {
                                    type: "number",
                                    placeholder: "请输入使用积分的零售价",
                                  },
                                  model: {
                                    value: _vm.detail.pointPrice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "pointPrice", $$v)
                                    },
                                    expression: "detail.pointPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "销售积分", prop: "point" },
                            },
                            [
                              _c("el-input", {
                                staticClass: "max-width",
                                attrs: {
                                  type: "number",
                                  placeholder: "请输入销售积分",
                                },
                                model: {
                                  value: _vm.detail.point,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "point", $$v)
                                  },
                                  expression: "detail.point",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "券售价", prop: "couponPrice" },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "max-width",
                                  attrs: {
                                    type: "number",
                                    placeholder: "请输入使用券的零售价",
                                  },
                                  model: {
                                    value: _vm.detail.couponPrice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "couponPrice", $$v)
                                    },
                                    expression: "detail.couponPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "消费券", prop: "coupon" },
                            },
                            [
                              _c("el-input", {
                                staticClass: "max-width",
                                attrs: {
                                  type: "number",
                                  placeholder: "请输入所需消费券",
                                },
                                model: {
                                  value: _vm.detail.coupon,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "coupon", $$v)
                                  },
                                  expression: "detail.coupon",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: {
                                label: "配送费用",
                                prop: "freightPrice",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "max-width",
                                  attrs: {
                                    type: "number",
                                    placeholder: "请输入配送费用",
                                  },
                                  model: {
                                    value: _vm.detail.freightPrice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detail, "freightPrice", $$v)
                                    },
                                    expression: "detail.freightPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "商品库存", prop: "quantity" },
                            },
                            [
                              _c("el-input", {
                                staticClass: "max-width",
                                attrs: {
                                  type: "number",
                                  placeholder: "请输入商品库存量",
                                },
                                model: {
                                  value: _vm.detail.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "quantity", $$v)
                                  },
                                  expression: "detail.quantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "惊喜倍数", prop: "surprise" },
                            },
                            [
                              _c("el-input", {
                                staticClass: "max-width",
                                attrs: {
                                  type: "number",
                                  placeholder: "请输入惊喜值倍数",
                                },
                                model: {
                                  value: _vm.detail.surprise,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "surprise", $$v)
                                  },
                                  expression: "detail.surprise",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "商品介绍", name: "Introduction" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "planText" } },
                            [
                              _c("my-editor", {
                                attrs: {
                                  text: _vm.detail.planText,
                                  images: _vm.editorImages,
                                  "not-exists": _vm.deletedImages,
                                  "auto-focus": false,
                                },
                                on: {
                                  "update:text": function ($event) {
                                    return _vm.$set(
                                      _vm.detail,
                                      "planText",
                                      $event
                                    )
                                  },
                                  "update:images": function ($event) {
                                    _vm.editorImages = $event
                                  },
                                  "update:notExists": function ($event) {
                                    _vm.deletedImages = $event
                                  },
                                  "update:not-exists": function ($event) {
                                    _vm.deletedImages = $event
                                  },
                                  change: _vm.editorChange,
                                },
                                model: {
                                  value: _vm.detail.intro,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "intro", $$v)
                                  },
                                  expression: "detail.intro",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-collapse-item",
                {
                  staticStyle: { display: "none" },
                  attrs: { title: "商品规格", name: "Specification" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品名称" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入商品名称" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品名称" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入商品名称" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-image", {
            ref: "elImage",
            staticStyle: { width: "0", height: "0" },
            attrs: { src: _vm.previewImg, "preview-src-list": _vm.previewList },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-form-button-group" },
        [
          _c(
            "el-button",
            { attrs: { icon: "el-icon-back" }, on: { click: _vm.onBack } },
            [_vm._v("返回列表")]
          ),
          _c(
            "el-button",
            { attrs: { type: "info" }, on: { click: _vm.onCreateGoods } },
            [_vm._v("新增商品")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
            [_vm._v("提交保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }